import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=d5806856&"
import script from "./main-form.vue?vue&type=script&lang=js&"
export * from "./main-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports